import { ProductWithServices, Tariff } from '../types';
import { findFirstCruiseService } from '../filters';
import { isTariff } from '../guards';

export const getAvailableTariffs = (): Tariff[] => {
  return ['PUR', 'PLUS', 'PRO'];
};

export const getDefaultTariff = (): Tariff => 'PRO';

export const getTariffsFromProducts = (
  products: ProductWithServices[],
): Tariff[] => {
  return products.reduce<Tariff[]>((tariffs, product) => {
    let name = findFirstCruiseService(product)?.variant?.cabin.tariffType;

    if (!isTariff(name) || tariffs.includes(name)) {
      return tariffs;
    }

    return [...tariffs, name];
  }, []);
};
